var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

var __spreadArrays = this && this.__spreadArrays || function () {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) {
    s += arguments[i].length;
  }

  for (var r = Array(s), k = 0, i = 0; i < il; i++) {
    for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) {
      r[k] = a[j];
    }
  }

  return r;
};

import "mapbox-gl/dist/mapbox-gl.css";
import React, { Component, createRef } from "react";
import PropTypes from "prop-types";
import { isEqual, flatten, take, reverse, uniq, indexOf } from "lodash";
import mapboxgl from "mapbox-gl";
import Radius from "mapbox-gl-circle";
import MapboxDraw from "@mapbox/mapbox-gl-draw";
import { IconZoomIn, IconResizeToFit } from "@wrstudios/icons";
import Button from "../button/Button";
import { defaultMapOptions } from "./utils/map-config";
import { getLocationFromCas } from "./utils/user-location";
import { isValidCenter } from "./utils/user-location";
import { drawOptions, defaultMode } from "./utils/draw-config";
import { radiusOptions, defaultRadius } from "./utils/radius-config";
import { milesToMeters, metersToMiles } from "./utils/distance";
import { ToolsContainer, RadiusTool } from "./styled/draw-tools";
import { PolygonTool, RectangleTool } from "./styled/draw-tools";
import { AreaNameLayout, AreaNameInput } from "./styled/search-map";
import { Container, Tooltip, ZoomContent } from "./styled/search-map";
import SearchMarker from "./SearchMarker";

var SearchMap =
/** @class */
function (_super) {
  __extends(SearchMap, _super);

  function SearchMap() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.tooltipRef = createRef();
    _this.containerRef = createRef();
    _this.state = {
      isLoaded: false,
      isZoomedToSeeMore: false,
      shouldShowZoomToSeeMore: false,
      mode: defaultMode,
      selectedAreaId: "",
      selectedAreaName: "",
      priorityIds: []
    };

    _this.initializeMap = function () {
      return __awaiter(_this, void 0, void 0, function () {
        var _a, markers, isEmptyMapEnabled, mapboxApiToken, validMarkers, center, bounds_1;

        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              _a = this.props, markers = _a.markers, isEmptyMapEnabled = _a.isEmptyMapEnabled, mapboxApiToken = _a.mapboxApiToken;
              validMarkers = markers.filter(function (_a) {
                var lon = _a.lon,
                    lat = _a.lat;
                return !!lon && !!lat;
              });
              mapboxgl.accessToken = mapboxApiToken;
              if (!isEmptyMapEnabled) return [3
              /*break*/
              , 2];
              return [4
              /*yield*/
              , this.locateUser()];

            case 1:
              center = _b.sent();

              if (!this._isMounted) {
                return [2
                /*return*/
                ];
              }

              this.map = new mapboxgl.Map(__assign(__assign(__assign({}, defaultMapOptions), this.props.mapOptions), {
                center: center
              }));
              this.handleMapInitialized();
              return [3
              /*break*/
              , 3];

            case 2:
              if (validMarkers.length > 0) {
                bounds_1 = new mapboxgl.LngLatBounds();
                validMarkers.forEach(function (marker) {
                  bounds_1.extend([marker.lon, marker.lat]);
                });
                this.map = new mapboxgl.Map(__assign(__assign(__assign({}, defaultMapOptions), this.props.mapOptions), {
                  bounds: bounds_1,
                  fitBoundsOptions: {
                    padding: this.props.zoomPadding
                  }
                }));
                this.handleMapInitialized();
              }

              _b.label = 3;

            case 3:
              return [2
              /*return*/
              ];
          }
        });
      });
    };

    _this.handleMapInitialized = function () {
      if (!_this.map) {
        return;
      }

      if (!_this.props.isScrollZoomEnabled) {
        _this.map.scrollZoom.disable();
      }

      _this.map.on("load", function () {
        _this.addAttribution();

        _this.addNavigation();

        _this.addMapHandlers();

        _this.addDrawControls();

        _this.addDrawHandlers();

        _this.addInitialAreas();

        _this.addInitialRadius();

        _this.setInitialZoom();

        _this.handleLoaded();
      });
    };

    _this.locateUser = function () {
      return __awaiter(_this, void 0, void 0, function () {
        var _a, env, casJwt, center, defaultCenter, sessionCenter, casCenter;

        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              _a = this.props, env = _a.env, casJwt = _a.casJwt, center = _a.center;
              defaultCenter = [center.lon, center.lat];

              if (!env || !casJwt) {
                return [2
                /*return*/
                , defaultCenter];
              }

              sessionCenter = window.sessionStorage.getItem("casUserLocation");

              if (isValidCenter(JSON.parse(sessionCenter))) {
                return [2
                /*return*/
                , JSON.parse(sessionCenter)];
              }

              return [4
              /*yield*/
              , getLocationFromCas({
                env: env,
                casJwt: casJwt
              })];

            case 1:
              casCenter = _b.sent();

              if (isValidCenter(casCenter)) {
                window.sessionStorage.setItem("casUserLocation", JSON.stringify(casCenter));
                return [2
                /*return*/
                , casCenter];
              }

              return [2
              /*return*/
              , defaultCenter];
          }
        });
      });
    };

    _this.addAttribution = function () {
      _this.map.addControl(new mapboxgl.AttributionControl({
        compact: true
      }), "top-left");
    };

    _this.addNavigation = function () {
      _this.map.addControl(new mapboxgl.NavigationControl({
        showCompass: _this.props.showCompass,
        showZoom: _this.props.showZoom
      }), "bottom-right");
    };

    _this.addMapHandlers = function () {
      _this.map.on("dragend", _this.handleBoundsUpdate);

      _this.map.on("zoomend", _this.handleBoundsUpdate);
    };

    _this.addDrawControls = function () {
      if (!_this.props.isDrawSearchEnabled) {
        return;
      }

      _this.draw = new MapboxDraw(drawOptions);

      _this.map.addControl(_this.draw);
    };

    _this.addDrawHandlers = function () {
      if (!_this.props.isDrawSearchEnabled) {
        return;
      }

      _this.map.on("draw.modechange", _this.handleDrawMode);

      _this.map.on("draw.create", _this.handleAreaCreate);

      _this.map.on("draw.update", _this.handleAreaUpdate);

      _this.map.on("draw.delete", _this.handleAreaDelete);

      _this.map.on("draw.selectionchange", _this.handleAreaSelect);
    };

    _this.addInitialAreas = function () {
      if (!_this.draw || _this.props.areas.length === 0) {
        return;
      }

      var areaIds = _this.props.areas.reduce(function (state, _a) {
        var coordinates = _a.coordinates;
        var area = {
          type: "Polygon",
          coordinates: [coordinates]
        };

        var id = _this.draw.add(area);

        return __spreadArrays(state, [id[0]]);
      }, []);

      _this.props.onAreasAdded({
        areaIds: areaIds,
        draw: _this.draw
      });
    };

    _this.addInitialRadius = function () {
      var radius = _this.props.radius;

      if (!radius) {
        return;
      }

      var meters = milesToMeters(radius.radius);
      var lngLat = {
        lng: radius.lon,
        lat: radius.lat
      };
      var instance = new Radius(lngLat, meters, radiusOptions);
      _this.radius = instance.addTo(_this.map);

      _this.addRadiusHandlers();
    };

    _this.addRadiusHandlers = function () {
      _this.radius.on("centerchanged", _this.handleRadiusUpdate);

      _this.radius.on("radiuschanged", _this.handleRadiusUpdate);

      _this.radius.on("click", _this.handleRadiusDelete);
    };

    _this.handleLoaded = function () {
      if (_this._isMounted) {
        var isZoomedToSeeMore = _this.map.getZoom() >= _this.props.zoomToSeeMoreThreshold;

        _this.setState({
          isLoaded: true,
          isZoomedToSeeMore: isZoomedToSeeMore,
          shouldShowZoomToSeeMore: !isZoomedToSeeMore
        });

        _this.props.onLoaded({
          zoom: _this.map.getZoom(),
          mapBounds: _this.getMapBounds()
        });
      }
    };

    _this.setInitialZoom = function (initialCoords) {
      if (_this.props.isInitialZoomDisabled) {
        return;
      }

      _this.zoomToFitContent(initialCoords);
    };

    _this.automaticallyZoom = function (initialCoords) {
      if (_this.props.isAutoZoomDisabled) {
        return;
      }

      _this.zoomToFitContent(initialCoords);
    };

    _this.zoomToFitContent = function (initialCoords) {
      if (initialCoords === void 0) {
        initialCoords = [];
      }

      var _a = _this.props,
          markers = _a.markers,
          boundMarkers = _a.boundMarkers,
          areas = _a.areas;
      var validMarkers = (boundMarkers || markers).filter(function (_a) {
        var lon = _a.lon,
            lat = _a.lat;
        return !!lon && !!lat;
      });
      var markerCoords = validMarkers.map(function (_a) {
        var lon = _a.lon,
            lat = _a.lat;
        return [lon, lat];
      });
      var areaCoords = flatten(areas.map(function (_a) {
        var coordinates = _a.coordinates;
        return coordinates;
      }));
      var radiusCoords = !_this.radius ? [] : Object.values(_this.radius.getBounds()).map(function (_a) {
        var lat = _a.lat,
            lng = _a.lng;
        return [lng, lat];
      });
      var contentCoords = markerCoords.concat(areaCoords).concat(radiusCoords);
      var coordinates = initialCoords.concat(contentCoords);

      if (_this.map && coordinates.length > 0) {
        var lngLatBounds_1 = new mapboxgl.LngLatBounds();
        coordinates.forEach(function (coordinate) {
          return lngLatBounds_1.extend(coordinate);
        });

        _this.map.resize();

        _this.map.fitBounds(lngLatBounds_1, {
          padding: _this.props.zoomPadding,
          animate: false
        });

        if (_this._isMounted) {
          _this.forceUpdate();
        }
      }
    };

    _this.changeMode = function (requestedMode) {
      if (!_this.props.isDrawSearchEnabled) {
        return;
      }

      var isSameMode = requestedMode === _this.state.mode;
      var nextMode = isSameMode ? defaultMode : requestedMode;

      _this.handleDrawMode({
        mode: nextMode
      });

      if (nextMode === "radius") {
        _this.draw.changeMode(defaultMode);

        _this.startRadiusMode();
      } else {
        _this.draw.changeMode(nextMode);

        _this.stopRadiusMode();
      }
    };

    _this.getAreaFromDrawEvent = function (event) {
      var area = event.features[0] || {};
      var coordinates = (area.geometry || {}).coordinates || [];
      return {
        id: area.id,
        coordinates: flatten(coordinates)
      };
    };

    _this.handleDrawMode = function (event) {
      _this.setState({
        mode: event.mode
      });
    };

    _this.handleAreaCreate = function (event) {
      var area = _this.getAreaFromDrawEvent(event);

      _this.props.onAreaCreate({
        area: area,
        draw: _this.draw
      });
    };

    _this.handleAreaUpdate = function (event) {
      var area = _this.getAreaFromDrawEvent(event);

      _this.props.onAreaUpdate({
        area: area,
        draw: _this.draw
      });
    };

    _this.handleAreaDelete = function (event) {
      var area = _this.getAreaFromDrawEvent(event);

      _this.props.onAreaDelete({
        area: area,
        draw: _this.draw
      });

      if (_this._isMounted) {
        _this.setState({
          selectedAreaId: ""
        });
      }
    };

    _this.handleAreaSelect = function (event) {
      var area = _this.getAreaFromDrawEvent(event);

      _this.props.onAreaSelect({
        area: area,
        draw: _this.draw
      });

      _this.setState({
        selectedAreaId: area.id || ""
      });
    };

    _this.handleNewStyles = function (prevProps) {
      if (prevProps.mapOptions.style === _this.props.mapOptions.style) {
        return;
      }

      var style = _this.props.mapOptions.style || defaultMapOptions.style;
      if (_this.map) _this.map.setStyle(style);
    };

    _this.handleNewAreas = function (prevProps) {
      if (!_this.draw) {
        return;
      }

      if (prevProps.areas.length !== _this.props.areas.length) {
        _this.draw.deleteAll();

        _this.addInitialAreas();

        _this.automaticallyZoom();
      }
    };

    _this.handleNewMarkers = function (prevProps) {
      var isEmptyMapEnabled = _this.props.isEmptyMapEnabled;
      var shouldShowZoomToSeeMore = _this.state.shouldShowZoomToSeeMore;
      var prevMarkers = prevProps.markers;
      var prevMarkerIds = prevMarkers.map(function (_a) {
        var id = _a.id;
        return id;
      });
      var nextMarkers = _this.props.markers;
      var nextMarkerIds = nextMarkers.map(function (_a) {
        var id = _a.id;
        return id;
      });
      var hasNewMarkers = !isEqual(prevMarkerIds, nextMarkerIds);
      var hasFirstMarkers = !prevMarkerIds.length && !!nextMarkerIds.length;
      var areNextMarkersInBounds = (_this.props.boundMarkers || nextMarkers).filter(function (_a) {
        var lon = _a.lon,
            lat = _a.lat;
        return !!lon && !!lat;
      }).every(function (_a) {
        var lat = _a.lat,
            lon = _a.lon;
        var lonLat = new mapboxgl.LngLat(lon, lat);
        if (!_this.map) return false;
        return _this.map.getBounds().contains(lonLat);
      });

      if (!areNextMarkersInBounds && !shouldShowZoomToSeeMore) {
        if (!_this._isMounted) return;

        _this.setState({
          shouldShowZoomToSeeMore: true
        });
      }

      if (hasFirstMarkers && !isEmptyMapEnabled && !_this.state.isLoaded) {
        _this.initializeMap();
      } else if (hasNewMarkers) {
        _this.automaticallyZoom();
      }
    };

    _this.handleRadiusRemoved = function (prevProps) {
      if (prevProps.radius && !_this.props.radius && _this.radius) {
        _this.radius.remove();

        _this.radius = null;
      }
    };

    _this.handleSelectedAreaName = function (prevProps) {
      if (!_this.props.selectedAreaName) {
        return;
      }

      if (prevProps.selectedAreaName !== _this.props.selectedAreaName) {
        _this.setState({
          selectedAreaName: _this.props.selectedAreaName
        });
      }
    };

    _this.handlePriorityId = function (_a) {
      var priorityId = _a.priorityId;

      if (_this.props.priorityId && _this.props.priorityId !== priorityId) {
        _this.setState(function (_a) {
          var priorityIds = _a.priorityIds;

          var nextIds = __spreadArrays([_this.props.priorityId], priorityIds);

          return {
            priorityIds: take(uniq(nextIds), 9)
          };
        });
      }
    };

    _this.handleAreaNameInput = function (event) {
      _this.setState({
        selectedAreaName: event.target.value
      });
    };

    _this.handleAreaNameSave = function () {
      var _a = _this.state,
          selectedAreaId = _a.selectedAreaId,
          selectedAreaName = _a.selectedAreaName;
      var area = {
        id: selectedAreaId,
        name: selectedAreaName
      };

      _this.props.onAreaRename({
        area: area,
        draw: _this.draw
      });

      _this.setState({
        selectedAreaId: ""
      });

      _this.changeMode(defaultMode);
    };

    _this.handleBoundsUpdate = function () {
      if (_this._isMounted) {
        var zoomLevel = _this.map.getZoom();

        var isZoomedToSeeMore = zoomLevel >= _this.props.zoomToSeeMoreThreshold;

        _this.setState({
          isZoomedToSeeMore: isZoomedToSeeMore,
          shouldShowZoomToSeeMore: !isZoomedToSeeMore
        });

        _this.props.onBoundsUpdate({
          zoom: _this.map.getZoom(),
          center: _this.map.getCenter(),
          mapBounds: _this.getMapBounds(),
          isLoaded: _this.state.isLoaded
        });
      }
    };

    _this.handleZoomToSeeMore = function () {
      var zoomLevel = _this.props.zoomToSeeMoreThreshold;
      _this.map.getZoom() >= zoomLevel ? _this.zoomToFitContent() : _this.map.zoomTo(zoomLevel);
    };

    _this.getMapBounds = function () {
      var bounds = _this.map.getBounds();

      var northWest = bounds.getNorthWest();
      var northEast = bounds.getNorthEast();
      var southEast = bounds.getSouthEast();
      var southWest = bounds.getSouthWest();
      return [[northWest.lng, northWest.lat], [northEast.lng, northEast.lat], [southEast.lng, southEast.lat], [southWest.lng, southWest.lat]];
    };

    _this.startRadiusMode = function () {
      if (!_this.props.isRadiusSearchEnabled) {
        return;
      }

      _this.map.getContainer().classList.add("mode-radius");

      _this.map.on("click", _this.handleRadiusCreate);
    };

    _this.stopRadiusMode = function () {
      if (!_this.props.isRadiusSearchEnabled) {
        return;
      }

      _this.map.getContainer().classList.remove("mode-radius");

      _this.map.off("click", _this.handleRadiusCreate);
    };

    _this.transformRadius = function (radius) {
      return {
        lon: radius.center[0],
        lat: radius.center[1],
        radius: metersToMiles(radius.radius)
      };
    };

    _this.handleRadiusCreate = function (event) {
      if (_this.radius) {
        return;
      }

      var instance = new Radius(event.lngLat, defaultRadius, radiusOptions);
      _this.radius = instance.addTo(_this.map);

      _this.addRadiusHandlers();

      _this.automaticallyZoom();

      _this.changeMode(defaultMode);

      _this.props.onRadiusCreate({
        radius: _this.transformRadius(instance)
      });
    };

    _this.handleRadiusUpdate = function (radius) {
      _this.props.onRadiusUpdate({
        radius: _this.transformRadius(radius)
      });
    };

    _this.handleRadiusDelete = function (event) {
      var transformedRadius = _this.transformRadius(_this.radius);

      _this.radius.remove();

      _this.radius = null;

      _this.changeMode(defaultMode);

      _this.map.getCanvas().style.cursor = "";

      _this.props.onRadiusDelete({
        radius: transformedRadius
      });
    };

    _this.addTooltipListener = function () {
      window.addEventListener("mousemove", _this.tooltipListener);
    };

    _this.removeTooltipListener = function () {
      window.removeEventListener("mousemove", _this.tooltipListener);
    };

    _this.tooltipListener = function (event) {
      var tootip = _this.tooltipRef.current;
      var container = _this.containerRef.current;
      var xOffset = window.innerWidth - container.offsetWidth;
      var yOffset = window.innerHeight - container.offsetHeight;
      tootip.style.top = event.clientY - yOffset - 30 + "px";
      tootip.style.left = event.clientX - xOffset + 6 + "px";
    };

    _this.getMarkerZindex = function (markerId) {
      var priorityIds = _this.state.priorityIds;

      if (!priorityIds.includes(markerId)) {
        return 1;
      }

      return indexOf(reverse(__spreadArrays(priorityIds)), markerId) + 2;
    };

    _this.getTooltipText = function () {
      switch (_this.state.mode) {
        case "draw_polygon":
          return "click to draw a polygon";

        case "rectangle":
          return "click to draw a rectangle";

        case "radius":
          return "click to draw a circle";

        default:
          return "";
      }
    };

    return _this;
  }

  SearchMap.prototype.render = function () {
    var _this = this;

    var _a = this.props,
        markers = _a.markers,
        mapOptions = _a.mapOptions,
        isSaveAreasEnabled = _a.isSaveAreasEnabled;
    var _b = this.props,
        isDrawSearchEnabled = _b.isDrawSearchEnabled,
        isRadiusSearchEnabled = _b.isRadiusSearchEnabled;
    var _c = this.state,
        mode = _c.mode,
        isLoaded = _c.isLoaded,
        selectedAreaId = _c.selectedAreaId,
        selectedAreaName = _c.selectedAreaName;
    var isZoomToSeeMoreEnabled = this.props.isZoomToSeeMoreEnabled;
    var _d = this.state,
        isZoomedToSeeMore = _d.isZoomedToSeeMore,
        shouldShowZoomToSeeMore = _d.shouldShowZoomToSeeMore;
    var validMarkers = markers.filter(function (_a) {
      var lon = _a.lon,
          lat = _a.lat;
      return !!lon && !!lat;
    });
    var containerId = mapOptions.container || defaultMapOptions.container;
    return React.createElement(Container, {
      id: containerId,
      ref: this.containerRef
    }, isLoaded && isZoomToSeeMoreEnabled && shouldShowZoomToSeeMore && React.createElement(ZoomContent, {
      onClick: this.handleZoomToSeeMore
    }, isZoomedToSeeMore ? React.createElement(React.Fragment, null, React.createElement(IconResizeToFit, null), "Resize to see all comps") : React.createElement(React.Fragment, null, React.createElement(IconZoomIn, null), "Zoom in to see more listings")), isSaveAreasEnabled && selectedAreaId && React.createElement(AreaNameLayout, null, React.createElement(AreaNameInput, {
      onChange: this.handleAreaNameInput,
      value: selectedAreaName
    }), React.createElement(Button, {
      onClick: this.handleAreaNameSave
    }, "Save")), isDrawSearchEnabled && React.createElement(ToolsContainer, null, React.createElement(PolygonTool, {
      onClick: function onClick() {
        return _this.changeMode("draw_polygon");
      },
      disabled: !isLoaded || !!selectedAreaId,
      isActive: mode === "draw_polygon"
    }), React.createElement(RectangleTool, {
      onClick: function onClick() {
        return _this.changeMode("rectangle");
      },
      disabled: !isLoaded || !!selectedAreaId,
      isActive: mode === "rectangle"
    }), isRadiusSearchEnabled && React.createElement(RadiusTool, {
      onClick: function onClick() {
        return _this.changeMode("radius");
      },
      disabled: !isLoaded || !!selectedAreaId || !!this.radius,
      isActive: mode === "radius"
    })), React.createElement(Tooltip, {
      id: "tooltip",
      mode: mode,
      ref: this.tooltipRef
    }, this.getTooltipText()), isLoaded && validMarkers.map(function (marker) {
      return React.createElement(SearchMarker, __assign({}, marker, {
        map: _this.map,
        zIndex: marker.zIndex || _this.getMarkerZindex(marker.id),
        key: marker.id
      }));
    }));
  };

  SearchMap.prototype.componentDidMount = function () {
    this.initializeMap();
    this.addTooltipListener();
    this._isMounted = true;
  };

  SearchMap.prototype.componentDidUpdate = function (prevProps) {
    this.handleNewStyles(prevProps);
    this.handleNewAreas(prevProps);
    this.handleNewMarkers(prevProps);
    this.handleRadiusRemoved(prevProps);
    this.handleSelectedAreaName(prevProps);
    this.handlePriorityId(prevProps);
  };

  SearchMap.prototype.componentWillUnmount = function () {
    this.removeTooltipListener();
    this._isMounted = false;
  };

  return SearchMap;
}(Component);

SearchMap.defaultProps = {
  mapOptions: {// "mapOptions" matches the mapbox.Map(options: Object) API
    // https://docs.mapbox.com/mapbox-gl-js/api/#map
    // keys inside "mapOptions" will be merged with "defaultMapOptions"
  },
  center: {
    lat: 33.65804,
    lon: -118.001521
  },
  areas: [],
  markers: [],
  zoomPadding: 120,
  zoomToSeeMoreThreshold: 15,
  showZoom: true,
  showCompass: false,
  onLoaded: function onLoaded() {},
  onAreasAdded: function onAreasAdded() {},
  onAreaCreate: function onAreaCreate() {},
  onAreaUpdate: function onAreaUpdate() {},
  onAreaDelete: function onAreaDelete() {},
  onAreaSelect: function onAreaSelect() {},
  onAreaRename: function onAreaRename() {},
  onRadiusCreate: function onRadiusCreate() {},
  onRadiusUpdate: function onRadiusUpdate() {},
  onRadiusDelete: function onRadiusDelete() {},
  onBoundsUpdate: function onBoundsUpdate() {}
};
SearchMap.propTypes = {
  env: PropTypes.oneOf(["production", "staging", "development", "test"]),
  casJwt: PropTypes.string,
  mapboxApiToken: PropTypes.string.isRequired,
  priorityId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  center: PropTypes.shape({
    lat: PropTypes.number.isRequired,
    lon: PropTypes.number.isRequired
  }),
  markers: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    lat: PropTypes.number.isRequired,
    lon: PropTypes.number.isRequired,
    component: PropTypes.element.isRequired,
    popupComponent: PropTypes.element,
    debug: PropTypes.bool
  })).isRequired,
  boundMarkers: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    lat: PropTypes.number.isRequired,
    lon: PropTypes.number.isRequired,
    component: PropTypes.element.isRequired,
    popupComponent: PropTypes.element,
    debug: PropTypes.bool
  })),
  areas: PropTypes.arrayOf(PropTypes.shape({
    coordinates: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.number)).isRequired
  })),
  radius: PropTypes.shape({
    lat: PropTypes.number.isRequired,
    lon: PropTypes.number.isRequired,
    radius: PropTypes.number.isRequired
  }),
  mapOptions: PropTypes.object,
  zoomPadding: PropTypes.number,
  zoomToSeeMoreThreshold: PropTypes.number,
  showZoom: PropTypes.bool,
  showCompass: PropTypes.bool,
  isEmptyMapEnabled: PropTypes.bool,
  isSaveAreasEnabled: PropTypes.bool,
  isDrawSearchEnabled: PropTypes.bool,
  isRadiusSearchEnabled: PropTypes.bool,
  isScrollZoomEnabled: PropTypes.bool,
  isInitialZoomDisabled: PropTypes.bool,
  isAutoZoomDisabled: PropTypes.bool,
  isZoomToSeeMoreEnabled: PropTypes.bool,
  selectedAreaName: PropTypes.string,
  onLoaded: PropTypes.func,
  onAreasAdded: PropTypes.func,
  onAreaCreate: PropTypes.func,
  onAreaUpdate: PropTypes.func,
  onAreaDelete: PropTypes.func,
  onAreaSelect: PropTypes.func,
  onAreaRename: PropTypes.func,
  onRadiusCreate: PropTypes.func,
  onRadiusUpdate: PropTypes.func,
  onRadiusDelete: PropTypes.func,
  onBoundsUpdate: PropTypes.func
};
export default SearchMap;